import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  withApollo,
  Query,
} from 'react-apollo';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Skeleton from '@iris-platform/iris-react-ui';
import {
  GET_USER,
  GET_TEAM,
} from '../queries';
import { stylesToPropType } from '../../../utils';

const styles = () => ({
  root: {
    width: '100%',
  },
  saveButton: {
    borderRadius: '0.125em',
    marginTop: '1em',
    width: '5em',
  },
});

class CurrentOwner extends Component {
  render() {
    const { ownerId } = this.props;

    return (
      <div>
        <Query
          query={GET_USER}
          notifyOnNetworkStatusChange
          variables={{ userID: ownerId }}
        >
          {({ data, loading, error }) => {
            if (loading) return null;
            if (error) return `Error!: ${error}`;

            if (data.user !== null && data.user !== undefined && data.user !== {}) {
              return (
                <div>
                  <TextField
                    label="User Email"
                    value={data.user.auminfo.email}
                    placeholder="User Email"
                    fullWidth
                    disabled
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                  />
                  <br />
                  <TextField
                    label="User Name"
                    value={data.user.auminfo.user_name}
                    placeholder="User Name"
                    fullWidth
                    disabled
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                  />
                  <br />
                  <TextField
                    label="OwnerID"
                    value={data.user.user_id}
                    placeholder="OwnerID"
                    fullWidth
                    disabled
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                  />
                </div>
              );
            }
            return <div />;
          }}
        </Query>
        <Query
          query={GET_TEAM}
          notifyOnNetworkStatusChange
          variables={{ id: ownerId }}
        >
          {({ data, loading, error }) => {
            if (loading) return null;
            if (error) return `Error!: ${error}`;

            if (data.team !== null && data.team !== undefined && data.team !== {}) {
              return (
                <div>
                  <TextField
                    label="User Name"
                    value={data.team.display_name}
                    placeholder="User Name"
                    fullWidth
                    disabled
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                  />
                  <br />
                  <TextField
                    label="OwnerID"
                    value={data.team.team_id}
                    placeholder="OwnerID"
                    fullWidth
                    disabled
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                  />
                </div>
              );
            }
            return <div />;
          }}
        </Query>
      </div>
    );
  }
}

CurrentOwner.propTypes = {
  ownerId: PropTypes.string.isRequired,
  client: PropTypes.object.isRequired,
};

export default withApollo(withStyles(styles)(CurrentOwner));
